import * as React from 'react';
import { connect } from 'react-redux';
import { useAppSelector } from '../store';
import { LoadingSpinner } from '@qualtrics/ui-react';
import { Link } from 'react-router-dom';

const Home = () => {

    // get values from Redux store
    const bearerToken = useAppSelector(state => state.bearerToken.value);
    const clientID = useAppSelector(state => state.clientID.value);

    
    // returns link to login to Qualtrics and redirects back to home page
    function getLoginURL() {
        try {
            if (clientID) {
                var redirectURI = window.location.href;
                var urlLogin = `https://ca1.qualtrics.com/oauth2/auth?client_id=${clientID}&response_type=code&scope=manage:all&state=RavZ3r2QvpQA25tXP0QN&redirect_uri=${redirectURI}`;
                return urlLogin;
            }
            
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <div>
            {bearerToken === "" 
                ? <div>
                    {new URLSearchParams(window.location.search).get('code')
                        ? <div className="loadingSpinner"><LoadingSpinner show size="large" /></div>
                        : <a href={getLoginURL()}>Log into Qualtrics</a>
                    }
                    </div>
                : <div>
                    <p>You're logged in</p>
                    
                    <p className="pageLinks">Navigate to the <Link to="/responses">View Survey Responses</Link> or <Link to="/update">Update Embedded Data</Link> tabs</p>
                </div>
                      
            }
        </div>
    )
};

export default connect()(Home);
